import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_2 = { class: "w-100" }

import { reactive, ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import type { FormInstance } from "element-plus";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import { useStore } from "@/store";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityReportForm',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(true);
const modalRef = ref<InstanceType<typeof SimpleForm>>();

const store = useStore();
const _email = store.state.AuthModule?.user?.email;
const id = ref(0);

const ruleFormRef = ref<FormInstance>();

const validateFromIsLessThanTo = (rule, value, callback) => {
  if (formData.value.from >= formData.value.to) {
    callback(new Error("End Date must larger than Start Date"));
  } else {
    callback();
  }
};

const rules = reactive<any>({
  email: [
    {
      required: true,
      message: "Please input from",
      trigger: "blur",
    },
  ],

  from: [
    {
      required: true,
      message: "Please input from",
      trigger: "blur",
    },
  ],
  to: [
    {
      required: true,
      message: "Please input to",
      trigger: "blur",
    },
    { validator: validateFromIsLessThanTo, trigger: "blur" },
  ],
});

const formData = ref<any>({
  id: id.value,
  email: _email,
  from: "",
  to: "",
  bcc: [],
});

const submit = async () => {
  isLoading.value = true;
  formData.value.id = id.value;
  console.log(formData.value);
  if (!ruleFormRef.value) return;

  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) {
    isLoading.value = false;
    return;
  }

  try {
    processDate();
    await AccountService.getActivityReport(
      formData.value.id,
      formData.value
    ).then(MsgPrompt.success("success"));
  } catch (error) {
    MsgPrompt.error(error);
  }

  isLoading.value = false;
};

const processDate = () => {
  formData.value.from = moment(formData.value.from).local().toISOString();
  formData.value.to = moment(formData.value.to).local().toISOString();
};

const show = async (_id: number) => {
  isLoading.value = true;
  id.value = _id;
  modalRef.value?.show();
  resetForm();

  isLoading.value = false;
};

const hide = () => {
  modalRef.value?.hide();
};

const resetForm = () => {
  if (!ruleFormRef.value) return;
  ruleFormRef.value.resetFields();
};



__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('title.sendActivityReport'),
    "is-loading": isLoading.value,
    submit: submit,
    style: {"width":"500px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: formData.value,
            rules: rules,
            "label-width": "120px",
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.startDate'),
                prop: "from"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: formData.value.from,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.from) = $event)),
                    type: "datetime",
                    placeholder: "Pick a start day"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.endDate'),
                prop: "to"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: formData.value.to,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.to) = $event)),
                    type: "datetime",
                    placeholder: "Pick a end day"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.receiverEmail'),
                prop: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})